// カレンダーの表示設定（表示するスタッフ・表示するイベントメニュー）の計算。
//
// 以前は「表示するものの一覧（ホワイトリスト）」を localStorage に保存していたため、
// 保存後に増えたスタッフ・メニューは一覧に無く、最初からオフになっていた（B10）。
// いまは「隠すものの一覧（ブラックリスト）」を正とし、一覧に無いもの＝表示とする。
//
// 旧ホワイトリストからの移行:
//   その店舗の一覧を初めて見たとき（seenIds に1件も無いとき）だけ、
//   旧ホワイトリストに無いものを隠す一覧へ移す。以降に増えたもの（seenIds に無いもの）は表示。
//   旧ホワイトリストが今の一覧と1件も重ならない（未保存・別店舗の値）なら移行しない
//   ＝すべて表示（従来の「未選択なら全部表示」と同じ結果）。
//   id は店舗をまたいで一意なので、隠す一覧・見た一覧は店舗ごとに分けず1本で持つ。

const toArray = v => (Array.isArray(v) ? v : [])
const union = (a, b) => a.concat(b.filter(id => !a.includes(id)))

export function syncVisibility({ allIds, legacyVisibleIds, hiddenIds, seenIds }) {
  const all = toArray(allIds)
  const legacy = toArray(legacyVisibleIds)
  let hidden = toArray(hiddenIds)
  const seen = toArray(seenIds)

  // 一覧の読み込み前は何も決めない（ここで決めると全件を「新しく増えた」扱いにしてしまう）
  if (all.length === 0) {
    return { visibleIds: legacy, hiddenIds: hidden, seenIds: seen }
  }

  const firstTime = !all.some(id => seen.includes(id))
  if (firstTime && legacy.some(id => all.includes(id))) {
    hidden = union(hidden, all.filter(id => !legacy.includes(id)))
  }

  // 全部隠れていたら全部表示に戻す（従来の「未選択なら全部表示」。画面を開いたときだけ効く）
  if (all.every(id => hidden.includes(id))) {
    hidden = hidden.filter(id => !all.includes(id))
  }

  return {
    visibleIds: visibleIdsFor(all, hidden),
    hiddenIds: hidden,
    seenIds: union(seen, all)
  }
}

// 表示するもの＝いまの一覧 − 隠す一覧（並びは一覧の順）
export function visibleIdsFor(allIds, hiddenIds) {
  const hidden = toArray(hiddenIds)
  return toArray(allIds).filter(id => !hidden.includes(id))
}

export function changeVisibility({ allIds, visibleIds, hiddenIds, seenIds }) {
  const all = toArray(allIds)
  const visible = toArray(visibleIds)
  // 今の一覧に無い id（別店舗・読み込み前）の隠す設定はそのまま残す
  const keep = toArray(hiddenIds).filter(id => !all.includes(id))
  return {
    visibleIds: visible,
    hiddenIds: keep.concat(all.filter(id => !visible.includes(id))),
    seenIds: union(toArray(seenIds), all)
  }
}
